import React from 'react'

const ViewMarker = ({ showInfo }) => {
  return (
    // <img
    //   onClick={showInfo}
    //   src="https://img.icons8.com/dusk/64/000000/marker.png"
    //   alt=""
    //   style={{
    //     width: '40px',
    //     height: '40px',
    //     position: 'absolute',
    //     top: '-35px',
    //     left: '-20px',
    //   }}
    // />
    <div class="Mapcircle hover"  style={{backgroundImage:"../assets/img/Group7.png"}}>
    <span class="circleText">
    <img src="../assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
    </span>
  </div>

  );
}
export default ViewMarker
